// extracted by mini-css-extract-plugin
export var csatScore = "_k4-5";
export var header = "_k4-1";
export var panelWrapper = "_k4-2";
export var postPreview = "_k4-3";
export var rightContent = "_k4-0";
export var wrappingText = "_k4-4";